import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=11a65f52&functional=true"
import script from "./subMenu.vue?vue&type=script&lang=js"
export * from "./subMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a65f52')) {
      api.createRecord('11a65f52', component.options)
    } else {
      api.rerender('11a65f52', component.options)
    }
    module.hot.accept("./subMenu.vue?vue&type=template&id=11a65f52&functional=true", function () {
      api.rerender('11a65f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/sideBar/subMenu.vue"
export default component.exports